
class AngelSnowParticle {
  constructor(parentCont, maxX) {
    // const
    this.maxY = 500;
    this.maxX = maxX;
    this.FADE_Y = 100;
    this.FADE_DIFF = this.maxY - this.FADE_Y;

    // props
    this.parentCont = parentCont;

    // vars
    this.tempScale = 1.0;
    this.vX = 0.0;
    this.vY = 0.0;

    // parts
    this.ptc = null;

    // init
    this.init();
  }

  // --------------------------------------------------------------
  // Init
  // --------------------------------------------------------------

  init() {
    this.ptc = new PIXI.Sprite.fromFrame('p-snow.png');
  }

  // --------------------------------------------------------------
  // Reset
  // --------------------------------------------------------------

  reset(randomY) {
    this.parentCont.addChild(this.ptc);
    this.ptc.x = Math.random() * this.maxX;
    this.ptc.alpha = 0.3 + (Math.random() * 0.7);
    this.tempScale = 0.5 + (Math.random() * 0.5);
    this.ptc.scale.x = this.tempScale;
    this.ptc.scale.y = this.tempScale;
    this.vX = -0.03 + (Math.random() * 0.06);
    this.vY = 0.35 + (Math.random() * 0.35);

    if (randomY) {
      // random y
      this.ptc.y = Math.random() * this.maxY;
    } else {
      // random top
      this.ptc.y = Math.random() * 10;
    }
  }

  remove() {
    this.parentCont.removeChild(this.ptc);
  }

  // --------------------------------------------------------------
  // Update
  // --------------------------------------------------------------

  lUp() {
    this.ptc.x += this.vX;
    this.ptc.y += this.vY;

    if (this.ptc.y > this.maxY) {
      this.remove();
      return false;
    } if (this.ptc.y > this.FADE_DIFF) {
      this.ptc.alpha = (this.maxY - this.ptc.y) / this.FADE_Y;
    }
    return true;
  }
}

export default AngelSnowParticle;



// WEBPACK FOOTER //
// ./src/js/scene/parts/heaven/parts/AngelSnowParticle.js